var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAccountProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}.cls-2{fill:#00a0df;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.13,
    y: 0.62,
    width: 600,
    height: 600
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "user_account_profile"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M405,337a153.63,153.63,0,0,1,78.51,21.1,155.67,155.67,0,0,1,57.42,57.42A153.63,153.63,0,0,1,562,494.06v49.22q0,23.44-16.41,39.85t-39.84,16.4H93.29q-23.45,0-39.85-16.4T37,543.28V494.06a153.72,153.72,0,0,1,21.09-78.51,155.75,155.75,0,0,1,57.42-57.42A153.64,153.64,0,0,1,194.07,337H214a204.54,204.54,0,0,0,171.1,0Zm-105.47-37.5q-41,0-75.59-19.92a146,146,0,0,1-54.49-54.49q-19.92-34.58-19.92-75.59T169.46,74A146,146,0,0,1,224,19.45Q258.52-.47,299.54-.47t75.58,19.92A145.91,145.91,0,0,1,429.62,74q19.92,34.56,19.92,75.58t-19.92,75.59a146,146,0,0,1-54.5,54.49Q340.56,299.53,299.54,299.53Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAccountProfile);
export default __webpack_public_path__ + "static/media/user_account_profile.5c27f308e001f4379c6fc3c0b3fb00c9.svg";
export { ForwardRef as ReactComponent };